import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import ShippingItem from './ShippingItem';

import './styles/ShippingDataContent.css';

export default function ShippingDataContent({ shippingData, onSelectShippingData, onUpdateShippingData, onRemoveShippingData, close }) {
  const t = useTranslations('common.forms.add_artwork');
  return (
    <div className="shipping-data-content__container"> 
      <div className="shipping-data-content__header">
        <Text className="shipping-data-content__header-text">
          {t('shipping.saved_rates')}
        </Text>
        <XIcon className="shipping-data-content__close" onClick={close} />
      </div>

      <Text className="shipping-data-content__text" paragraph>
        {t('shipping.saved_rates_description')}
      </Text>

      {shippingData.map(item => (
        <ShippingItem 
          key={item._id} 
          data={item}
          onSelectShippingData={onSelectShippingData}
          onUpdateShippingData={onUpdateShippingData}
          onRemoveShippingData={onRemoveShippingData}
        />
      ))}
      
    </div>
  );
}
